<template>
	<div class="header" :class="{ bg: hasBg }">
		<img class="logo" src="@/assets/images/logo.png" />
		<div class="nav">
			<a @click="goHome()">首页</a>
			<a @click="goHX()">核心优势</a>
			<a @click="goNews()">新闻中心</a>
			<a @click="goFW()">产品服务</a>
			<a @click="goYJ()">企业愿景</a>
			<a @click="goAbout()">关于我们</a>
			<div class="btn1" style="margin-left: 20px;">
				校区管理中心
				<ul>
					<li>
						<a href="https://eso-agent.jmnet.cn" target="_blank">机构管理平台</a>
					</li>
					<li>
						<a href="https://cloud.fadada.com/application/account/login" target="_blank">法大大签约</a>
					</li>
				</ul>
			</div>
			<div class="btn1">
				学员管理中心
				<ul>
					<li>
						<a href="https://xmbxx.kaowx.com/login" target="_blank">必过</a>
					</li>
					<li>
						<a href="https://jsbxx.myunedu.com/#/phoneLogin/index" target="_blank">慧学</a>
					</li>
					<li>
						<a href="https://jypxzxzaixian.myunedu.com/#/homePage" target="_blank">易过</a>
					</li>
					<li>
						<a href="https://future.gzfeice.com" target="_blank">飞策</a>
					</li>
				</ul>
			</div>
			<div class="btn2">
				教务管理中心
				<ul>
					<li>
						<a href="https://oem.beeeeego.com/" target="_blank">必过</a>
					</li>
					<li>
						<a href="https://bxx.myunedu.com/" target="_blank">慧学</a>
					</li>
					<li>
						<a href="https://scrm.gzfeice.com/" target="_blank">飞策</a>
					</li>
				</ul>
			</div>
			<div class="btn3">
				公众号
				<div class="code-outer">
					<div class="code">
						<img src="@/assets/images/code.png" />
						<span>关注微信公众号</span>
					</div>
				</div>
			</div>
			<div class="btn4">
				报名咨询
				<div class="code">
					<img src="@/assets/images/code-1.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	scrollTo
} from '@/scroll-to.js'
export default {
	data() {
		return {
			hasBg: false,
			hasBgDefault: false,
		}
	},
	created() {

	},
	mounted() {
		if (this.$route.path === '/news' || this.$route.path === '/detail') {
			this.hasBg = true
			this.hasBgDefault = true
		} else {
			this.hasBg = false
			this.hasBgDefault = false
		}
		window.addEventListener('scroll', this.handleScroll);
	},
	computed: {},
	watch: {
		'$route'(to, from) {
			if (to.path === '/news' || to.path === '/detail') {
				this.hasBg = true
				this.hasBgDefault = true
			} else {
				this.hasBg = false
				this.hasBgDefault = false
			}
		}
	},
	methods: {
		handleScroll() {
			if (this.hasBgDefault) {
				return
			}

			const scrollPosition = window.scrollY;
			if (scrollPosition >= 200) {
				this.hasBg = true
			} else {
				this.hasBg = false
			}
		},

		goAbout() {
			scrollTo(0)
			if (window.location.hash !== '#/about') {
				this.$router.push('/about')
			}
		},
		goYJ() {
			scrollTo(4695)
			if (window.location.hash !== '#/') {
				this.$router.push('/')
			}
		},
		goHX() {
			scrollTo(600)
			if (window.location.hash !== '#/') {
				this.$router.push('/')
			}
		},
		goFW() {
			scrollTo(2418)
			if (window.location.hash !== '#/') {
				this.$router.push('/')
			}
		},
		goHome() {
			scrollTo(0)
			if (window.location.hash !== '#/') {
				this.$router.push('/')
			}
		},
		goNews() {
			this.$router.push('/news')
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	components: {}
}
</script>

<style scoped lang="less">
.header {
	padding: 20px 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: fixed;
	z-index: 9;
	left: 0;
	right: 0;
	top: 0;
}

.bg {
	background: #0f2fbe;
}

.logo {
	height: 40px;
	width: auto;
}

.nav {
	display: flex;
	align-items: center;

	a {
		margin-left: 24px;
		color: #fff;
		font-size: 16px;
		cursor: pointer;

		&:hover {
			font-weight: 500;
		}
	}

	.btn1 {
		position: relative;
		// width: 144px;
		padding: 0 14px;
		height: 40px;
		color: #fff;
		font-size: 16px;
		border-radius: 2px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border: #fff 1px solid;
		box-sizing: border-box;

		&:hover {
			background: rgba(255, 255, 255, 0.1);

			ul {
				display: block;
			}
		}

		ul {
			display: none;
			position: absolute;
			background: #fff;
			border-radius: 2px;
			right: 0;
			left: 0;
			top: 40px;
			padding: 10px;
			box-shadow: rgba(0, 0, 0, 0.05) 0 10px 30px;

			li {
				a {
					padding: 6px 0;
					display: block;
					color: #333;
					margin: 0;
					font-size: 16px;
				}
			}
		}
	}

	.btn2 {
		position: relative;
		border-radius: 2px;
		padding: 0 14px;
		background: linear-gradient(to right, #39a3f4, #1a7efc);
		// width: 144px;
		height: 40px;
		color: #fff;
		font-size: 17px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		border: #1a7efd 1px solid;
		cursor: pointer;

		&:hover {
			background: #0d6de6;

			ul {
				display: block;
			}
		}

		ul {
			display: none;
			position: absolute;
			background: #fff;
			border-radius: 2px;
			right: 0;
			left: 0;
			top: 40px;
			padding: 10px 0 10px 20px;
			box-shadow: rgba(0, 0, 0, 0.05) 0 10px 30px;

			li {
				a {
					padding: 6px 0;
					display: block;
					color: #333;
					margin: 0;
					font-size: 16px;
				}
			}
		}
	}

	.btn3 {
		padding: 0 14px;
		position: relative;
		border-radius: 2px;
		background: #1a7efd;
		// width: 83px;
		height: 40px;
		color: #fff;
		font-size: 16px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.code-outer {
			display: none;
			position: absolute;
			z-index: 9;
			top: 40px;
			left: 0px;
			padding: 20px 0;
		}

		.code {
			background: #fff;
			border-radius: 8px;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 10px;

			img {
				width: 111px;
				height: auto;
				display: block;
			}

			span {
				color: #a6a6a6;
				font-size: 13px;
			}
		}

		&:hover {
			background: #0d6de6;

			.code-outer {
				display: flex;
			}
		}
	}

	.btn4 {
		padding: 0 14px;
		position: relative;
		border-radius: 2px;
		background: #1a7efd;
		height: 40px;
		color: #fff;
		font-size: 16px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.code {
			display: none;
			position: absolute;
			z-index: 9;
			top: 40px;
			right: 0px;
			border-radius: 8px;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 20px 0;

			img {
				width: 205px;
				height: auto;
				display: block;
			}
		}

		&:hover {
			background: #0d6de6;

			.code {
				display: flex;
			}
		}
	}
}
</style>